import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Game, GamesService, DynamicFormComponent, Client } from 'core/index';
import { GamesQuestionsService } from '../questions-services/games-questions.service';

@Component({
  selector: 'lms-game-editor',
  templateUrl: './game-editor.component.html',
  styleUrls: ['./game-editor.component.scss']
})
export class GameEditorComponent implements OnInit {
  @Input() game: Game;
  @Input() client: Client;
  @Input() defaults: any;
  @Output() saved = new EventEmitter<Game>();
  @ViewChild(DynamicFormComponent, { static: false }) public dynamicForm: DynamicFormComponent;
  public questions: any[];
  public clientIdQuestion: any;

  constructor(public gamesService: GamesService, public gamesQuestions: GamesQuestionsService) {}

  ngOnInit() {
    this.questions = this.gamesQuestions.getQuestions(this.game, this.client);
    this.clientIdQuestion = this.questions.find((question) => question.key === 'clientId');
  }

  submit(gameData: any) {
    if (this.game) {
      this.onUpdate(gameData);
    } else {
      this.onCreate(gameData);
    }
  }

  onCreate(gameData: Object) {
    this.gamesService
      .create(Object.assign(gameData, this.defaults))
      .then((game) => {
        this.saved.emit(game);
        this.endSubmit(null);
      })
      .catch((err) => {
        this.endSubmit(err);
      });
  }

  onUpdate(updatedData: Object) {
    const updatedgame: Game = Object.assign({}, this.game, updatedData, this.defaults);
    this.gamesService
      .update(updatedgame)
      .then((game) => {
        this.saved.emit(updatedgame);
        this.endSubmit(null);
      })
      .catch((err) => {
        this.endSubmit(err);
      });
  }

  endSubmit(value) {
    this.dynamicForm.submitted(value);
  }
}
